namespace Matrix.Data {
    export class TestGroupTestColumns {
        static columnsKey = 'Data.TestGroupTest';
    }
}
